import { TopicMarkModel } from '@/dmdrive/topic/entities/TopicMark';

import { FlatRemark } from '@carbon/dm-industrial/lib/dm-industrial';

export function groupRemarks(existingMarks: TopicMarkModel[], allMarks: FlatRemark[]) {
  const existingMarksMap = existingMarks.reduce<Record<string, FlatRemark>>(
    (result, mark) => ({
      ...result,
      [mark.meta.id]: mark.meta,
    }),
    {},
  );

  const allMarksMap = allMarks.reduce<Record<string, FlatRemark>>(
    (result, mark) => ({
      ...result,
      [mark.id]: mark,
    }),
    {},
  );

  const toRemove = Object.keys(existingMarksMap).filter((id) => !allMarksMap[id]);

  const toAdd = Object.keys(allMarksMap).filter((id) => !existingMarksMap[id]);

  const toUpdate = Object.keys(allMarksMap)
    .filter((id) => !toRemove.includes(id) && !toAdd.includes(id))
    .filter((id) => JSON.stringify(existingMarksMap[id]) !== JSON.stringify(allMarksMap[id]));

  return {
    toRemove,
    toAdd: toAdd.map((id) => ({ type: 'carbon', meta: allMarksMap[id] })),
    toUpdate: toUpdate.map((id) => ({ id, type: 'carbon', meta: allMarksMap[id] })),
  };
}
